"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useEventListener_1 = __importDefault(require("./useEventListener"));
function useMergeRefs({ ref }) {
    const [isHovered, setIsHover] = (0, react_1.useState)(false);
    const setHovered = (0, react_1.useCallback)((event) => {
        const element = ref && ref.current;
        const isEventHover = event.target === element;
        setIsHover(isEventHover);
    }, [setIsHover, ref]);
    const setNotHovered = (0, react_1.useCallback)(() => setIsHover(false), [setIsHover]);
    (0, useEventListener_1.default)({ eventName: "mouseenter", callback: setHovered, ref });
    (0, useEventListener_1.default)({ eventName: "mouseleave", callback: setNotHovered, ref });
    return isHovered;
}
exports.default = useMergeRefs;
